
























import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import ChallengeCard from "@/components/ChallengeCard.vue";
import NextChallengeCard from "@/components/NextChallengeCard.vue";
import StatisticsCard from "@/components/StatisticsCard.vue";

@Component({
  components: {
    ChallengeCard,
    NextChallengeCard,
    StatisticsCard,
  },
  computed: mapGetters(["allChallengeResultsForCampaign", "oneCampaign"]),
})
export default class CampaignOverview extends Vue {
  @Prop(Boolean) private readonly includeCountdown!: boolean;
  @Prop({ required: true }) private readonly id!: number;

  get campaign() {
    return this.$store.getters.oneCampaign(this.id);
  }
}
